import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2202,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 32,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xaqzuld6_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/punxywqy_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/obloewfk_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/osqew3wi_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ceaagpoz_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 90,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/knihskiu_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Chats"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 42,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8ur7gwqg_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p9ggutww_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5yp73zuo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/453r904i_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jdv0osor_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5h0uuvbe_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vg7r4xjo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f78e0lol_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hsfq62ay_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z7h9mft5_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xv2qj4cx_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rlkovz5a_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0a20zjjk_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Chats"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 29,
								marginRight: 23,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 81,
								}}>
								<span 
									style={{
										color: "#000000",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 92,
									}} >
									{"All Chats"}
								</span>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Groups"}
								</span>
							</div>
							<div 
								style={{
									width: 74,
									height: 3,
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderTopLeftRadius: 8,
									borderTopRightRadius: 9,
									marginLeft: 79,
								}}>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 225,
									marginBottom: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d2dkyxqq_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search chat..."}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 88,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vnhlze2w_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginRight: 84,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Alexandra Joes"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 5,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"10:20 AM"}
									</span>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-end",
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mlp496nn_expires_30_days.png"} 
											style={{
												width: 19,
												height: 19,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ejbvefas_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 81,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Bernadette"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"Yesterday"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/anh9rp7m_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 72,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Elizabeth"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"12/02/2024"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k1d4luy1_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 72,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Katherine"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"12/02/2024"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t7bbesy0_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 72,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Madeleine"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"12/02/2024"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a3ddmp13_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 81,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Bernadette"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Hello, I’m here to help you..."}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"Yesterday"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1u7il16m_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginTop: 7,
										marginRight: 157,
									}} >
									{"Elizabeth"}
								</span>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"12/02/2024"}
								</span>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 797,
								background: "#E6E6E6",
								marginRight: 1,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 21,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
									marginLeft: 32,
									marginRight: 32,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mhf7g54w_expires_30_days.png"} 
									style={{
										width: 35,
										height: 35,
										marginRight: 11,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Alexandra Joes"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 10,
										}} >
										{"Online"}
									</span>
								</div>
								<div 
									style={{
										width: 105,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jtab1cgv_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 10,
									marginLeft: 17,
									marginRight: 17,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 16,
									border: `1px solid #E6E6E6`,
									paddingTop: 4,
									paddingBottom: 4,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 24,
									marginLeft: 325,
									boxShadow: "0px 0px 1px #00000003",
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 10,
										fontWeight: "bold",
									}} >
									{"Today"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 30,
									marginLeft: 32,
									gap: 8,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s4axpx2d_expires_30_days.png"} 
										style={{
											width: 36,
											height: 36,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "#E7F1F8",
											borderTopLeftRadius: 4,
											borderTopRightRadius: 16,
											borderBottomRightRadius: 16,
											borderBottomLeftRadius: 16,
											paddingTop: 12,
											paddingBottom: 13,
											paddingLeft: 12,
											paddingRight: 12,
										}}>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 13,
												width: 229,
											}} >
											{"Same here! Has anyone gone through the ‘Market Research’ lesson yet? I’d love to discuss key takeaways."}
										</span>
									</div>
								</div>
								<span 
									style={{
										color: "#979797",
										fontSize: 10,
										marginLeft: 44,
									}} >
									{"10:01 AM"}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
									marginBottom: 30,
								}}>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-end",
										marginRight: 26,
										gap: 8,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#2BBCF2",
											borderTopLeftRadius: 16,
											borderTopRightRadius: 4,
											borderBottomRightRadius: 16,
											borderBottomLeftRadius: 16,
											paddingTop: 12,
											paddingBottom: 13,
											paddingLeft: 12,
											paddingRight: 37,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 13,
												width: 213,
											}} >
											{"Great to see you all engaging! Let’s make this a collaborative space for growth. Don’t hesitate to ask questions!"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 6,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 10,
											}} >
											{"10:03 AM"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3fnoiubw_expires_30_days.png"} 
											style={{
												width: 12,
												height: 12,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 30,
									marginLeft: 32,
									gap: 8,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/flfitwal_expires_30_days.png"} 
										style={{
											width: 36,
											height: 36,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#E7F1F8",
											borderTopLeftRadius: 4,
											borderTopRightRadius: 16,
											borderBottomRightRadius: 16,
											borderBottomLeftRadius: 16,
											paddingTop: 12,
											paddingBottom: 13,
											paddingLeft: 12,
											paddingRight: 35,
										}}>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 13,
												width: 215,
											}} >
											{"Does anyone have a good business plan template to share?"}
										</span>
									</div>
								</div>
								<span 
									style={{
										color: "#979797",
										fontSize: 10,
										marginLeft: 44,
									}} >
									{"10:01 AM"}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
									marginBottom: 73,
								}}>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-end",
										marginRight: 26,
										gap: 8,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "#2BBCF2",
											borderTopLeftRadius: 16,
											borderTopRightRadius: 4,
											borderBottomRightRadius: 16,
											borderBottomLeftRadius: 16,
											paddingTop: 12,
											paddingBottom: 13,
											paddingLeft: 12,
											paddingRight: 12,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 13,
												width: 230,
											}} >
											{"I have a solid business plan template that covers key sections like market analysis, financial projections, and strategy. Let me know if you'd like me to share it!"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 6,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 10,
											}} >
											{"10:03 AM"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/stw9ejbu_expires_30_days.png"} 
											style={{
												width: 12,
												height: 12,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderTopLeftRadius: 16,
									borderTopRightRadius: 16,
									borderBottomRightRadius: 16,
									paddingTop: 20,
									paddingBottom: 32,
									paddingLeft: 32,
									paddingRight: 32,
									boxShadow: "0px -2px 4px #00000000",
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										marginTop: 4,
										marginBottom: 4,
										marginRight: 414,
									}} >
									{"Write your message..."}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										gap: 10,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bnhmnh20_expires_30_days.png"} 
										style={{
											width: 27,
											height: 27,
											objectFit: "fill",
										}}
									/>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5smjex66_expires_30_days.png"} 
										style={{
											width: 27,
											height: 27,
											objectFit: "fill",
										}}
									/>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dwl9q8p4_expires_30_days.png"} 
										style={{
											width: 27,
											height: 27,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}